<template>
  <div>
    <transition name="fade">
      <div class="bg" v-if="isLoading">
        <div class="loader">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t('common.loading') }}</span>
          </div>
        </div>
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  data() {
    return {};
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.bg {
  background-color: rgba(255, 255, 255, 0.7);
  height: 100vh;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.loader {
  z-index: 3;
  position: absolute;
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .spinner-border {
    width: 100px;
    height: 100px;
    border: 0.1em solid currentColor;
    border-right-color: transparent;
  }
}
</style>
